import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);

const isMobileOrTabletPwa = () => {
  const touchFirst = window.matchMedia("(pointer: coarse)").matches || navigator.maxTouchPoints > 1;
  const mobileOrTabletWidth = window.matchMedia("(max-width: 1366px)").matches;
  const narrowScreen = window.matchMedia("(max-width: 1024px)").matches;
  return mobileOrTabletWidth && (touchFirst || narrowScreen);
};

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    if (isMobileOrTabletPwa()) {
      navigator.serviceWorker.register("/service-worker.js").catch((error) => {
        console.warn("Flax Seed PWA service worker registration failed:", error);
      });
      return;
    }
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
  });
}
